export enum SheetsEnum {
  SKIP_ACTION = "skip-action",
  MODULES_LIST = "modules-list",
  MODULE_ACCESS = "module-access",
  AREA_LOCK = "area-lock",
  ACTION = "action",
  ACTION_IN_PROGRESS = "action-in-progress",
  SCAN_MODULE = "scan-module",
  CLIMATE_RAINFALL_VIEW = "climate-rainfall-view",
  CLIMATE_ATMOSPHERIC_VIEW = "climate-atmospheric-view",
  CLIMATE_HISTORY_CHOICE = "climate-history-choice",
  WEATHER_FORECAST = "weather-forecast",
  PROTECTION_LIST = "protection-list",
  PROTECTION_DETAIL = "protection-detail",
}
